import apiCall from "./axios_instance";
import config from '../config.json';
import { AXIOS, DEFAULT_PAGE_SIZE, LOCAL_STORAGE_KEYS, MAX_SEARCH_SCRIP_PER_PAGE, productDetails } from "../utils/global_variables";
import { getStorageWithMultiTabCheck } from "../utils/global_functions";
const { TenantId } = config;


export async function getDistinctExpirybyTokenApi(objPayload) {
    try {
        const objResp = await apiCall.get(`/nontransactional/${TenantId}/v1/getDistinctExpirybyToken/${objPayload?.assetToken}/${objPayload?.instrumentName}/${objPayload?.params}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in getDistinctExpirybyTokenApi API ->", error.message);
        throw error;
    }
}



export async function getScripFromInstrumentAndExchangeApi(objPayload) {
    try {
        const objResp = await apiCall.get(`/nontransactional/${TenantId}/v1/getScripFromInstrumentAndExchange/null/${objPayload?.expiryDate}/${objPayload?.symbol}/${objPayload?.nExchangesViewAllowed}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in getScripFromInstrumentAndExchangeApi API ->", error.message);
        throw error;
    }
}

export async function getAppSyncDetailsByTenant() {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/getAppSyncDetailsByTenant?tenantId=${TenantId}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in getAppSyncDetailsByTenant API ->", error.message);
        throw error;
    }
};

export async function createUserPreference(payload) {
    try {
        const obj = {
            ...payload,
            guestAllowed: true
        };
        const objResp = await apiCall.post(`nontransactional/v1/userPreference`, obj);
        return objResp;
    } catch (error) {
        console.error("Error in userPreference API ->", error.message);
        throw error;
    }
};


export async function getAppSyncDetailsByUser() {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/getAppSyncDetailsByUser`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in getAppSyncDetailsByUser API ->", error.message);
        throw error;
    }
};



export async function getScripbyTokenAndMktSegId(payload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getScripbytokenandMktSegId`, {
            scrips: payload,
            guestAllowed: true
        });
        return objResp;
    } catch (error) {
        console.error("Error in getScripbyTokenAndMktSegId API ->", error);
        throw error;
    }
}


export async function getScripLookUp(sSearchText, mktAllowed, screenNumber = 0, totalNoOfElements = MAX_SEARCH_SCRIP_PER_PAGE) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getScripLookUp/${sSearchText}/${mktAllowed}/${screenNumber}/${totalNoOfElements}/true`, { guestAllowed: true });
        return objResp;

    } catch (error) {
        console.error("Error in getScripLookUp API ->", error.message);
        throw error;
    }
}

export async function getDistinctExpiry(sSearchText) {
    try {
        let objLoginSession = JSON.parse(getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getDistinctExpiry/${sSearchText}/OPT/${objLoginSession.nExchangesViewAllowed}`, { guestAllowed: true }); //BT-115082 : Creating common function for search : Generating ViewAllowed : ManasaB : 03/08/2023
        return objResp;

    } catch (error) {
        console.error("Error in getDistinctExpiry API ->", error.message);
        throw error;
    }
}

export async function createWatchList(payload) {
    try {
        const objPayload = {
            ...payload,
            guestAllowed: true
        };
        const objResp = await apiCall.post(`nontransactional/v1/watchListProfile`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in createWatchList API ->", error.message);
        throw error;
    }
};

export async function updateWatchList(objPayload) {
    try {
        const objResp = await apiCall.put(`nontransactional/v1/watchListProfile`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in updateWatchList API ->", error.message);
        throw error;
    }
};

export async function deleteWatchList(objPayload) { //convert prameters into an object
    try {
        const objResp = await apiCall.delete(`nontransactional/v1/watchListProfile?id=${objPayload?.strId}&_version=${objPayload?.strVersion}`);
        return objResp;
    } catch (error) {
        console.error("Error in deleteWatchList API ->", error.message);
        throw error;
    }
}

export async function indexDetails() {
    try {
        const objResp = await apiCall.get(`nontransactional/${config.TenantId}/v1/getIndexDetails`, { lock: true, guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in indexDetails API ->", error.message);
        throw error;
    }
}

export async function getRecommendations(allowedNewsCat, pageNo, pageSize) {
    try {
        // Not put axios instance apiCall it require no access token in header
        /* const objResp = await axios.get(`${config.Wave.URL}/nontransactional/${TenantId}/v1/recommendation/?allowedNewsCat=${allowedNewsCat}&pageNo=${pageNo}&pageSize=${pageSize}`, {
            timeout: AXIOS.TIMEOUT
        }); */
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/recommendation/?allowedNewsCat=${allowedNewsCat}&pageNo=${pageNo}&pageSize=${pageSize}`, {
            timeout: AXIOS.TIMEOUT
        });
        return (objResp);
    } catch (error) {
        console.error("Error in getRecommendations API ->", error.message);
        throw error;
    }
}

export async function appWaveScannerDetails() {
    try {
        const objResp = await apiCall.get(`nontransactional/${config.TenantId}/v1/getAppWaveScannerDetails`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in appWaveScannerDetails API ->", error.message);
        return []
    }
}
export async function scripFromInstandExchangeDetails(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${config.TenantId}/v1/getScripFromInstandExchange/${objPayload?.strInstrument}/null/${objPayload?.strSymbol}`);
        return objResp;
    } catch (error) {
        console.error("Error in scripFromInstandExchangeDetails API ->", error.message);
        return [];
    }
}
export async function whatsHotData() {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getWhatsHotData`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error('Error in whatsHotData API', error);
    }
}

export async function pushNotification() {

    try {
        console.error();
        const objResp = await apiCall.post(`loggerservice/apperror`);
        return objResp;

    } catch (error) {
        console.error('Error in pushNotification API', error);
    }
}




export async function uploadProfilePicture(objPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v2/uploadProfilePicture`, objPayload, { noEncrypt: true });
        return objResp;
    } catch (error) {
        console.error('Error in uploadProfilePicture API', error);
    }
}

export async function updateUserPrefernce(objPayload) {
    try {
        const objResp = await apiCall.put(`nontransactional/v1/userPreference`, objPayload);
        return objResp;
    } catch (error) {
        console.error('Error in userPreference API', error);
    }
}

export async function getUserPrefernce(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/userPreferenceByUser`, objPayload);
        return objResp;
    } catch (error) {
        console.error('Error in userPreference API', error);
    }
}
export async function getFCMNotification(objPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getFCMNotification`, objPayload);
        return objResp;
    } catch (error) {
        console.error('Error in getFCMNotification API', error);
    }
}

export async function brokerMessage(objPayload) {
    try {
        //const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/brokerMessages?pageNo=${objPayload.pageNo}&pageSize=10`);
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/brokerMessages`, {
            params: {
                pageNo: objPayload.pageNo,
                pageSize: DEFAULT_PAGE_SIZE.BROKER_MESSAGES_PAGE_SIZE

            }
        });
        return objResp;
    } catch (error) {
        console.error('Error in brokerMessages API', error);
    }
}

export async function ordersMessage(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/orderMessages?pageNo=${objPayload.pageNo}&pageSize=${DEFAULT_PAGE_SIZE.ORDER_MESSAGES_PAGE_SIZE}`);
        return objResp;
    } catch (error) {
        console.error('Error in ordersMessage API', error);
    }
}



export async function exchangeMessages(payload, allowedNewsCat) {

    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/exchangeMessages/${payload}?/noofhrs=${allowedNewsCat?.noofhrs}&pageNo=${allowedNewsCat?.pageNo}&pageSize=${allowedNewsCat?.pageSize}`);
        return objResp;

    } catch (error) {
        console.error('Error in exchangeMessages API', error);
    }
}
//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - Start
export async function getScripFromInstandExchange(payload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${config.TenantId}/v1/getScripFromInstandExchange/${payload.instrument}/null/${payload.symbol}/${payload?.nExchangesViewAllowed}`, { guestAllowed: true });
        return objResp;

    } catch (error) {
        console.error('Error in getScripFromInstandExchange API', error);
    }
}
//AzeemKhan : 17-05-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab - End

export async function securityDetails(objPayload) {

    const obj = {
        ...objPayload,
        guestAllowed: true
    };

    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getSecurityInfo`, obj);
        return objResp;
    } catch (error) {
        console.error("Error in securityDetails API ->", error.message);
    }
}

export async function contractDetails(objPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getContractInfo`, objPayload, { timeout: 25000 });
        return objResp;
    } catch (error) {
        console.error("Error in contractDetails API ->", error.message);
    }
}

export async function gsmGradeCategory(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getGSMGradeCategory/${objPayload.mktSegmentId}/${objPayload.nToken}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in gsmGradeCategory API ->", error.message);
    }
}

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start

export async function marginPlusParams(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getMarginPlusParams/${objPayload.mktSegmentId}/${objPayload.nToken}/${objPayload.strInstName}/${objPayload.strSymbol}/${objPayload.strSeries}/${objPayload.strExpDate}/${objPayload.strStrikePrice}/${objPayload.strOptionType}/-/${objPayload.strProductTypeCode}`);
        return objResp;
    } catch (error) {
        console.error("Error in marginPlusParams API ->", error.message);
    }
}

export async function bannedScripStatus(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getBannedScripStatus/${objPayload.mktSegmentId}/${objPayload.nToken}`);
        return objResp;
    } catch (error) {
        console.error("Error in getBannedScripStatus API ->", error.message);
    }
}
//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025 : Send multiple scrips at a time - Start
export async function getBannedScripsList(objPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getBannedScripStatus`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in getBannedScripsList API ->", error.message);
    }
}
//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025 : Send multiple scrips at a time - End
export async function getLTPPriceBandMaster() {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getLTPPriceBandMaster`);
        return objResp;
    } catch (error) {
        console.error("Error in getLTPPriceBandMaster API ->", error.message);
    }
}

export async function marketStatus() {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/marketStatus`);
        return objResp;
    } catch (error) {
        console.error("Error in marketStatus API ->", error.message);
    }
}

//Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

export async function getPutCallMaster(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/PutCallMasterData/${objPayload?.mktSegmentId}/${objPayload?.symbol}/1/null`);
        return objResp;
    } catch (error) {
        console.error("Error in PutCallMasterData API ->", error.message);
    }
}

export async function getOIDataForScrip(objPayload) {
    try {
        const objResp = await apiCall.get(`/nontransactional/${TenantId}/v1/OIDataForScrip/${objPayload.segmentId}/${objPayload?.nToken}/${objPayload?.expiry}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in OIDataForScrip API ->", error.message);
    }
}
export async function scripoverviewMarketPulse(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/FNOPulseData/${objPayload.mktSegmentId}/${objPayload.Symbol}/null/null`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in marketPulse API ->", error.message);
    }
}

export async function deleteUserColumnProfiles(payload) {
    try {
        const objResp = await apiCall.delete(`/nontransactional/v1/columnProfile?id=${payload?.id}&_version=${payload?.version}`);
        return objResp;
    } catch (error) {
        console.error("Error in deleteUserColumnProfiles API ->", error.message);
    }
}

//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start
export async function livePulse(objPayload) {
    try {
        const objResp = await apiCall.get(`/nontransactional/${TenantId}/v1/livePulseData/${objPayload?.nMarketSegmentId}/${objPayload.indexSector}/null`, { guestAllowed: true });

        return objResp;
    } catch (error) {
        console.error("Error in livePulse API ->", error.message);
    }
    //AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End
}

export async function scripoverviewMarketMovement(objPayload) {
    try {
        let obj = {
            ...objPayload,
            guestAllowed: true
        };
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getChartData`, obj);
        return objResp;
    } catch (error) {
        console.error("Error in marketPulse API ->", error.message);
    }
}


export async function getHistoricChartData(objPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/getHistoricChartData`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in marketPulse API ->", error.message);
    }
}

export async function getFcmUserTopicDetails() {
    try {
        const objResp = await apiCall.get(`/nontransactional/${TenantId}/v1/getFCMUserTopicDetails`);
        return objResp;
    } catch (error) {
        console.error("Error in FCM User topc details API ->", error.message);
    }
}

export async function indiceFutures(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getScripbyAssetToken/${objPayload?.nToken}/FUTIDX`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in indiceFutures API ->", error.message);
    }
}


export async function createUserColumnProfiles(objPayload) { // dont need id automatically created and version
    try {
        const objResp = await apiCall.post(`/nontransactional/v1/columnProfile`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in createUserColumnProfiles API ->", error.message);
    }
}

export async function updateUserColumnProfiles(objPayload) { // needs id and version
    try {
        const objResp = await apiCall.put(`/nontransactional/v1/columnProfile`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in updateUserColumnProfiles API ->", error.message);
    }
}

export async function getAnalyticsData(objPayload) {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getAnalyticsData/WaveScreener/${objPayload.segmentId}/${objPayload.indexSector}/${objPayload.RedisKeyPrefix}/${objPayload?.callSector}/${objPayload.month}`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in indiceFutures API ->", error.message);
    }
}

export async function indexSectorList() {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getIndexSectorList`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in getIndexSectorList API ->", error.message);
    }
}
// ---BT-107433_SrikanthRao_16-08-2023_Option Calculator || Functional Implementation

export async function getOptionChainData(objPayload) {

    /*payload structure will be objPAyload = {instrumentName,null,symbol,allowedId}*/

    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getScripFromInstandExchange/${objPayload?.instrumentName}/null/${objPayload?.symbol}/${objPayload?.allowedId}`);
        return objResp;
    } catch (error) {
        console.error('error', error);
    }
}
export async function scripAdditionalinfo(arrPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/scrip/additionalinfo`, { "scrip_info": arrPayload });
        // //Vaibhav Singh: 11-12-23: BT-109095: AdditionalInfo API updated: End
        return objResp;
    } catch (error) {
        console.error("Error in scripAdditionalinfo API ->", error.message);
    }
}

// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
export async function getAddendumAndNotices(payload) {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/addendumAndNotices?market_allowed=${payload?.nAllowedId}&login_type=${payload?.login_type}`);
        return objResp;
    } catch (error) {
        console.error("Error in sgetAddendumAndNotices API ->", error.message);
    }
}
// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
export async function acceptorRejectAddendumAndNotices(payload) {
    try {
        const objResp = await apiCall.post(`nontransactional/v1/addendumAndNotice`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in acceptorRejectAddendumAndNotices API ->", error.message);
        throw error;
    }
}
// Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End

/* BT-109369 Shuaib.P : Getting watchlist data by providing watchlist id --start  */

export async function getDataByWatchlistId(watchListId) {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/WatchListByUser/${watchListId}`);
        return objResp;
    } catch (error) {
        console.error("Error in getDataByWatchlistId API ->", error.message);
        throw error;
    }
}

/* BT-109369 Shuaib.P : Getting watchlist data by providing watchlist id --end */

// BT-115936 : Vinit Raut : 17-10-2023 : Breeze- Hamburger Menu- Exchange Links - Start
export async function getExchangeLinks() {
    try {
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getExchangeLinks`, { guestAllowed: true });
        return objResp;
    } catch (error) {
        console.error("Error in getExchangeLinks API ->", error.message);
        throw error;
    }
}
// BT-115936 : Vinit Raut : 17-10-2023 : Breeze- Hamburger Menu- Exchange Links - End


// Ajitesh : 04/12/2023: BT-109135: Breeze eDIS implementation - Start
export async function generateTpin(payload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v1/generateTPIN`, payload);
        return objResp;
    }
    catch (error) {
        console.error("Error in generateTPIN api ->", error.message);
        throw error;
    }
}
// Ajitesh : 04/12/2023: BT-109135: Breeze eDIS implementation - End


// Hari k :16-02-2024 funds start

export async function GetNonBusinessDays() {
    try {
        const objResp = await apiCall.get('nontransactional/v1/getNonBusinessDays');
        return objResp;

    } catch (error) {
        console.error("getNonBusinessDays ->", error.message);
        throw error;
    }
}
// Hari k :16-02-2024 funds end
// Ajitesh : 16/02/2024: BT-109380 Contact Us - Start
export async function getBranchesForContactUs() {
    try {
        // https://devwaveapi.odinwave.com/nontransactional/1524/v1/getBranchDetails
        const objResp = await apiCall.get(`nontransactional/${TenantId}/v1/getBranchDetails`);
        return objResp;
    }
    catch (error) {
        console.error("Error in getBranchDetails api ->", error.message);
        throw error;
    }
}
// Ajitesh : 16/02/2024: BT-109380 Contact Us - End

export async function userAddendumAndNoticesSummaryApi() {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/userAddendumAndNoticesSummary`);

        return objResp;
    } catch (error) {
        console.error("Error in userAddendumAndNoticesSummaryApi  ->", error.message);
        throw error;
    }
}

export async function setRegDetails(payload) {
    try {
        const objResp = await apiCall.post(`nontransactional/${TenantId}/v2/setRegDetail`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in setRegDetailApi  ->", error.message);
        throw error;

    }
}


export async function setCautionaryMsgDetails(objPayload) {
    try {
        const objResp = await apiCall.post(`nontransactional/v1/setCautionaryMsgDetails`, objPayload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in setCautionaryMsgDetails API ->", error.message);
    }
}

/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - Start */
export async function getSegmentWiseVersion() {
    try {
        const objResp = await apiCall.get(`nontransactional/v1/segmentVersion?source=${productDetails.productName}`);
        return objResp;
    } catch (error) {
        console.error("Error in segmentVersion->", error.message);
        throw error;
    }
}

/* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number - End */